<template>
  <div class="issues-summary-container">
    <PreLoaderSection
      :options="{ height: '500', enabledTwoColumns: true }"
      v-if="issuesDataLoading" />
    <div class="page-content issues" v-if="!issuesDataLoading">
      <div class="issues-total-summary">
        <IssuesTotalSummary :issuesData="issuesData" :error="error" v-if="issuesData" />
      </div>
      <div class="issues-category-summary mt-4">
        <IssuesCategorySummary :issuesData="issuesData" />
      </div>
    </div>
  </div>
</template>

<script>
import PreLoaderSection from '@/components/PreLoaderSection.vue';
import IssuesTotalSummary from '@/issues/IssuesTotalSummary.vue';
import IssuesCategorySummary from '@/issues/IssuesCategorySummary.vue';

export default {
  props: ['issuesData', 'issuesDataLoading'],
  components: {
    PreLoaderSection,
    IssuesTotalSummary,
    IssuesCategorySummary,
  },
  watch: {
    '$route.query': {
      async handler(queryString) {
        const filter = this.generateQuery(queryString);
        await this.loadTotalErrors(filter);
      },
    },
  },
  data() {
    return {
      dateFilter: null,
      issuesList: [],
      error: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
</style>
